{
  "name": "@last9/rum",
  "version": "2.0.34",
  "description": "Last9 Real User Monitoring (RUM) SDK for web applications",
  "main": "dist/l9.umd.js",
  "module": "dist/l9.esm.js",
  "types": "dist/l9.d.ts",
  "files": [
    "dist",
    "README.md"
  ],
  "scripts": {
    "build": "tsc && node build.js",
    "prepare": "yarn run build",
    "test": "jest src/**/*.test.ts",
    "watch": "nodemon --watch src --ext ts,js,json --exec 'yarn build'",
    "lint": "eslint 'src/**/*.{ts,tsx}'",
    "format": "prettier --write 'src/**/*.{ts,tsx,js,jsx,json,css,md}'"
  },
  "keywords": [
    "last9",
    "last9 browser",
    "last9 browser sdk",
    "last9 browser monitoring",
    "rum",
    "monitoring",
    "performance",
    "opentelemetry",
    "web-vitals"
  ],
  "author": "Last9",
  "license": "ISC",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/last9/browser.git"
  },
  "bugs": {
    "url": "https://github.com/last9/browser/issues"
  },
  "homepage": "https://github.com/last9/browser#readme",
  "devDependencies": {
    "@types/clientjs": "^0.2.2",
    "@types/jest": "^29.5.14",
    "@typescript-eslint/eslint-plugin": "^8.33.1",
    "@typescript-eslint/parser": "^8.33.1",
    "esbuild": "^0.25.0",
    "eslint": "^9.28.0",
    "eslint-plugin-simple-import-sort": "^12.1.1",
    "jest": "^29.7.0",
    "nodemon": "^3.1.10",
    "prettier": "^3.5.3",
    "ts-jest": "^29.3.2",
    "tsconfig-paths": "^4.2.0",
    "typescript": "^5.8.2"
  },
  "dependencies": {
    "@opentelemetry/api": "^1.9.0",
    "@opentelemetry/core": "^2.0.1",
    "@opentelemetry/exporter-logs-otlp-http": "^0.57.2",
    "@opentelemetry/exporter-trace-otlp-http": "^0.57.2",
    "@opentelemetry/otlp-transformer": "^0.57.2",
    "@opentelemetry/resources": "^1.30.1",
    "@opentelemetry/sdk-trace-web": "^1.30.1",
    "bowser": "^2.11.0",
    "clientjs": "^0.2.1",
    "web-vitals": "^4.2.4"
  },
  "directories": {
    "example": "examples"
  }
}
